import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import store from '@/store';
// import multiguard from 'vue-router-multiguard';
// import { usePostHog } from '@/composables/posthog';
import {
  DASHBOARD_ROUTE,
  LOGIN_ROUTE,
  SIGNUP_PROFILE_ROUTE,
  SIGNUP_ORGANIZATION_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  RESET_PASSWORD_ROUTE,
  NOT_FOUND_404_ROUTE,
  VERIFY_EMAIL_ROUTE,
  EMAIL_VERIFICATION_WALL_ROUTE,
  ERROR_ROUTE,
  SUPPORT_SESSION_ROUTE,
  ANNOUNCEMENTS_ROUTE,
  SET_PASSWORD_ROUTE,
  DISPLAY_ROUTE,
  SCREEN_SCHEDULE_DISPLAY_ROUTE,
  DONATIONS_ROUTE,
  EMAIL_ROUTE,
  TEXTS_ROUTE,
  ADD_ANNOUNCEMENT_ROUTE,
  EDIT_ANNOUNCEMENT_ROUTE,
  DUPLICATE_ANNOUNCEMENT_ROUTE,
  ADD_DONATION_ROUTE,
  YURTZEITEN_ROUTE,
  YURTZEITEN_N_ROUTE,
  RECENT_PHOTO_ROUTE,
  EVENTS_ROUTE,
  EVENTS_N_ROUTE,
  TICKETS_ROUTE,
  ADD_EVENT_ROUTE,
  EDIT_EVENT_ROUTE,
  DATE_TIME_BANNER_ROUTE,
  DONATION_SETTINGS_ROUTE,
  ANNOUNCEMENT_SETTINGS_ROUTE,
  RECENT_PHOTOS_SETTINGS_ROUTE,
  YURTZEITEN_SETTINGS_ROUTE,
  WEEKLY_EVENTS_ROUTE,
  ADD_WEEKLY_EVENT_ROUTE,
  WEEKLY_EVENTS_SETTINGS_ROUTE,
  WEEKLY_SCHEDULE_N_ROUTE,
  WEEKLY_SCHEDULE_DETAILS_N_ROUTE,
  EVENTS_SETTINGS_ROUTE,
  PHOTO_UNDERLINES_ROUTE,
  PUBLIC_SUBMISSION_ROUTE,
  YURTZEITEN_PUBLIC_FORM_ROUTE,
  YURTZEITEN_PUBLIC_FORM_LEGACY_ROUTE,
  ZMANIM_ROUTE,
  ZMANIM_N_ROUTE,
  ADD_ZMANIM_N_ROUTE,
  EDIT_ZMANIM_N_ROUTE,
  DUPLICATE_ZMANIM_N_ROUTE,
  SETTINGS_ROUTE,
  ZMANIM_SETTINGS_ROUTE,
  MINYANIM_N_ROUTE,
  MINYANIM_ROLLS_N_ROUTE,
  ADD_MINYANIM_ROLL_N_ROUTE,
  EDIT_MINYANIM_ROLL_N_ROUTE,
  DUPLICATE_MINYANIM_ROLL_N_ROUTE,
} from '@/router/routes';
import { ifNotAuthDeny } from '@/router/guards/not_auth';
import { installChunkReloadHandler } from '@/router/chunk_reload';
import { ifAuthDeny } from '@/router/guards/auth';
import DashboardView from '@/views/Dashboard.vue';
import LoginView from '@/views/auth/Login.vue';
// import { ifNotAdminDeny } from './guards/role';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: DASHBOARD_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: DashboardView,
  },
  {
    path: '/login',
    name: LOGIN_ROUTE,
    beforeEnter: ifAuthDeny,
    component: LoginView,
  },
  // {
  //   path: '/signup-profile',
  //   name: SIGNUP_PROFILE_ROUTE,
  //   beforeEnter: ifAuthDeny,
  //   component: () => import('@/views/auth/Signup_Profile.vue'),
  // },
  // {
  //   path: '/signup-organization',
  //   name: SIGNUP_ORGANIZATION_ROUTE,
  //   beforeEnter: ifAuthDeny,
  //   component: () => import('@/views/auth/Signup_Organization.vue'),
  // },
  {
    path: '/forgot-password',
    name: FORGOT_PASSWORD_ROUTE,
    // beforeEnter: ifAuthDeny,
    component: () => import('@/views/auth/Forgot_Password.vue'),
  },
  {
    path: '/reset-password/:token',
    name: RESET_PASSWORD_ROUTE,
    beforeEnter: ifAuthDeny,
    component: () => import('@/views/auth/Reset_Password.vue'),
  },
  {
    path: '/set-password/:token',
    name: SET_PASSWORD_ROUTE,
    // beforeEnter: ifAuthDeny,
    component: () => import('@/views/auth/Set_Password.vue'),
  },
  // {
  //   path: '/verify-email/:id',
  //   name: VERIFY_EMAIL_ROUTE,
  //   // beforeEnter: ifAuthDeny,
  //   component: () => import('@/views/auth/Verify_Email.vue'),
  // },
  // {
  //   path: '/email-verification-wall',
  //   name: EMAIL_VERIFICATION_WALL_ROUTE,
  //   // beforeEnter: ifNotAuthDeny,
  //   component: () => import('@/views/auth/Email_Verification_Wall.vue'),
  // },

  {
    path: '/community',
    name: ANNOUNCEMENTS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Announcement_N/Announcements_N.vue'),
  },
  {
    path: '/community/new',
    name: ADD_ANNOUNCEMENT_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/announcement/Register_Announcement.vue'),
  },
  {
    path: '/community/edit/:id',
    name: EDIT_ANNOUNCEMENT_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/announcement/Edit_Announcement.vue'),
  },
  {
    path: '/community/duplicate/:id',
    name: DUPLICATE_ANNOUNCEMENT_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/announcement/Duplicate_Announcement.vue'),
  },
  {
    path: '/announcement-old',
    name: 'ANNOUNCEMENTS_ROUTE_OLD',
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Announcements-Old.vue'),
  },
  {
    path: '/donations',
    name: DONATIONS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Donation_N/Donations_N.vue'),
  },
  {
    path: '/donations/new',
    name: ADD_DONATION_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/donation/Add_Donation.vue'),
  },
  {
    path: '/display/:id',
    name: DISPLAY_ROUTE,
    // beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Display.vue'),
  },
  {
    // A screen schedule's own link. Public like the screen link above, and it
    // never replaces it: each screen keeps /display/:id, which does not switch.
    path: '/display/schedule/:id',
    name: SCREEN_SCHEDULE_DISPLAY_ROUTE,
    component: () => import('@/views/Screen_Schedule_Display.vue'),
  },
  {
    path: '/texts',
    name: TEXTS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Text.vue'),
  },
  {
    path: '/yurtzeiten',
    name: YURTZEITEN_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/yurtzeiten/Yurtzeiten.vue'),
  },
  {
    path: '/yurtzeiten_N',
    name: YURTZEITEN_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Yurtzeiten_N/Yurtzeiten_N.vue'),
  },
  {
    path: '/recent-photos',
    name: RECENT_PHOTO_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/recent_photo/Recent_Photo.vue'),
  },
  {
    path: '/events',
    name: EVENTS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/event/Events.vue'),
  },
  {
    path: '/date-time-banner',
    name: DATE_TIME_BANNER_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/date_time_banner/Date_Time_Banner.vue'),
  },
  {
    path: '/zmanim',
    name: ZMANIM_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/zmanim/Zmanim.vue'),
  },
  {
    path: '/minyanim',
    name: MINYANIM_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Minyamin_N/Minyanim_N.vue'),
  },
  {
    path: '/minyanim-rolls',
    name: MINYANIM_ROLLS_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Minyamin_N/Minyanim_Rolls/Minyanim_Rolls_N.vue'),
  },
  {
    path: '/minyanim-rolls/add',
    name: ADD_MINYANIM_ROLL_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Minyamin_N/Minyanim_Rolls/Add_Minyanim_Roll.vue'),
  },
  {
    path: '/minyanim-rolls/edit/:id',
    name: EDIT_MINYANIM_ROLL_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Minyamin_N/Minyanim_Rolls/Edit_Minyanim_Roll.vue'),
  },
  {
    path: '/minyanim-rolls/duplicate/:id',
    name: DUPLICATE_MINYANIM_ROLL_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Minyamin_N/Minyanim_Rolls/Duplicate_Minyanim_Roll.vue'),
  },
  {
    path: '/zmanim_N',
    name: ZMANIM_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Zmanm_N/Zmanim_N.vue'),
  },
  {
    path: '/zmanim_N/add',
    name: ADD_ZMANIM_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Zmanm_N/Add_Zmanim_N.vue'),
  },
  {
    path: '/zmanim_N/edit/:id',
    name: EDIT_ZMANIM_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Zmanm_N/Edit_Zmanim_N.vue'),
  },
  {
    path: '/zmanim_N/duplicate/:id',
    name: DUPLICATE_ZMANIM_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Zmanm_N/Duplicate_Zmanim_N.vue'),
  },
  {
    path: '/settings',
    name: SETTINGS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/settings/Settings.vue'),
  },
  {
    path: '/settings/zmanim',
    name: ZMANIM_SETTINGS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/settings/Zmanim_Settings.vue'),
  },
  {
    path: '/email',
    name: EMAIL_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Email.vue'),
  },
  // {
  //   path: '/events',
  //   name: EVENTS_ROUTE,
  //   beforeEnter: ifNotAuthDeny,
  //   component: () => import('@/views/event/Events.vue'),
  // },
  {
    path: '/events-new',
    name: EVENTS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/event/Events_New.vue'),
  },
  {
    path: '/events_N',
    name: EVENTS_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/event_N/Events_N.vue'),
  },
  {
    path: '/events/new',
    name: ADD_EVENT_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/event/Add_Event.vue'),
  },
  {
    path: '/events/edit/:id',
    name: EDIT_EVENT_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/event/Edit_Event.vue'),
  },
  {
    path: '/tickets',
    name: TICKETS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/ticket/Tickets.vue'),
  },
  {
    path: '/settings/donation',
    name: DONATION_SETTINGS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/settings/Donation_Settings.vue'),
  },
  {
    path: '/settings/announcement',
    name: ANNOUNCEMENT_SETTINGS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/settings/Announcement_Settings.vue'),
  },
  {
    path: '/settings/recentPhotos',
    name: RECENT_PHOTOS_SETTINGS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/settings/Recent_Photos_Settings.vue'),
  },
  {
    path: '/settings/yurtzeiten',
    name: YURTZEITEN_SETTINGS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/settings/Yurtzeiten_Settings.vue'),
  },
  {
    path: '/settings/weekly-events',
    name: WEEKLY_EVENTS_SETTINGS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/settings/Weekly_Events_Settings.vue'),
  },
  {
    path: '/settings/events',
    name: EVENTS_SETTINGS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/settings/Events_Settings.vue'),
  },
  {
    path: '/weekly-events',
    name: WEEKLY_EVENTS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/weekly_event/Weekly_Events.vue'),
  },
  {
    path: '/weekly-schedule',
    name: WEEKLY_SCHEDULE_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Weekly_Schedule_N/Weekly_Schedules_N.vue'),
  },
  {
    path: '/weekly-schedule/:id',
    name: WEEKLY_SCHEDULE_DETAILS_N_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Weekly_Schedule_N/Weekly_Schedule_N.vue'),
  },
  {
    path: '/weekly-events/new',
    name: ADD_WEEKLY_EVENT_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/weekly_event/Add_Weekly_Event.vue'),
  },
  {
    path: '/photo-underlines',
    name: PHOTO_UNDERLINES_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/photo_underline/Photo_Underlines.vue'),
  },
  {
    path: '/content/public-submission',
    name: PUBLIC_SUBMISSION_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/public_submission/Public_Submission.vue'),
  },
  // The organization's shareable yahrzeit form. Public by design — no guard,
  // since the people filling it in have no account.
  //
  // The link is the organization's name on the app's domain and nothing else,
  // so the page resolves the organization by matching that slug. Declared
  // below every app route on purpose: Vue Router ranks a static segment above
  // a parameter, so `/settings` and friends still win and only an otherwise
  // unclaimed single segment lands here.
  {
    path: '/:organizationName',
    name: YURTZEITEN_PUBLIC_FORM_ROUTE,
    component: () => import('@/views/Yurtzeiten_N/Yurtzeiten_Public_Form.vue'),
  },
  // The shape the link had before it was shortened. Kept so a QR code or
  // flyer printed with the id on it still opens the form — that path resolves
  // by id, which also survives the organization being renamed.
  {
    path: '/:organizationName/yurtzeiten/:organizationId',
    name: YURTZEITEN_PUBLIC_FORM_LEGACY_ROUTE,
    component: () => import('@/views/Yurtzeiten_N/Yurtzeiten_Public_Form.vue'),
  },
  {
    // Where the Screenkode admin opens this app for a support session: in a
    // frame, signed in over postMessage (utils/support_session). No guard —
    // the page signs in by itself.
    path: '/support-session',
    name: SUPPORT_SESSION_ROUTE,
    component: () => import('@/views/auth/Support_Session.vue'),
  },
  {
    path: '/error',
    name: ERROR_ROUTE,
    component: () => import('@/views/Error.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: NOT_FOUND_404_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// A deploy replaces the content-hashed route chunks, and the service worker's
// asset cache can hold on to a stale one — recover instead of dead-ending.
installChunkReloadHandler(router);

// const { posthog } = usePostHog();

// router.afterEach(() => {
//   store.dispatch(UPDATE_ROUTER_LOADER, false);
//   posthog.capture('$pageview');
// });

// router.beforeEach((to, from) => {
//   if (from.path !== to.path) {
//     posthog.capture('$pageleave');
//   }
// });

export default router;
